import type { ReactNode } from "react";
import { DashboardMetricTile } from "./DashboardMetricTile";

type DashboardConnectedCardProps = {
  rootTestId: string;
  metricTestId: string;
  caption: string;
  totalNumber: number;
  metricClassName: string;
  valueClassName: string;
  sectionLabel: string;
  children: ReactNode;
  className?: string;
  sectionTestId?: string;
  actions?: ReactNode;
  captionTooltip?: ReactNode;
};

export const DashboardConnectedCard = ({
  rootTestId,
  metricTestId,
  caption,
  totalNumber,
  metricClassName,
  valueClassName,
  sectionLabel,
  children,
  className,
  sectionTestId,
  actions,
  captionTooltip,
}: DashboardConnectedCardProps) => {
  const rootClassName = [
    "flex min-h-0 min-w-0 flex-col gap-0 rounded",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={rootClassName} data-testid={rootTestId}>
      <DashboardMetricTile
        totalNumber={totalNumber}
        caption={caption}
        className={metricClassName}
        valueClassName={valueClassName}
        actions={actions}
        captionTooltip={captionTooltip}
        metricTestId={metricTestId}
      />
      <section
        className="flex min-h-0 flex-1 flex-col overflow-hidden rounded-b border border-t-0 border-solid border-gray-200 bg-white p-2"
        data-testid={sectionTestId}
        aria-label={sectionLabel}
        style={{
          paddingBottom: "14px",
        }}
      >
        {children}
      </section>
    </div>
  );
};
